import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LoginModule } from './feature/login/login.module';


const routes: Routes = [
  //home
  {path:'',redirectTo:'home',pathMatch:'full'},

  //features
  {path:'home', loadChildren:()=>import('./feature/home/home.module').then(h=>h.HomeModule)},
  {path:'entre', loadChildren:()=>import('./feature/entre/entre.module').then(e=>e.EntreModule)},
  {path:'exit', loadChildren:()=>import('./feature/exit/exit.module').then(ex=>ex.ExitModule)},
  {path:'pause', loadChildren:()=>import('./feature/pause/pause.module').then(p=>p.PauseModule)},
  {path:'info', loadChildren:()=>import('./feature/info/info.module').then(i=>i.InfoModule)},
  {path:'login', loadChildren:()=>import('./feature/login/login.module').then(l=>l.LoginModule)},
  {path:'pauseCode/:type', loadChildren:()=>import('./feature/pause/pause-code/pause-code.module').then(pc=>pc.PauseCodeModule)},
  
  {path:'**', redirectTo:'home',pathMatch:'full'}


];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {scrollPositionRestoration: 'enabled',preloadingStrategy: PreloadAllModules, onSameUrlNavigation:'reload'}
    )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
